export default __webpack_public_path__ + "static/media/Big.44381108.png";